import React, { useEffect, useState } from 'react'
import { Typography, Paper, Grid, Container } from '@mui/material'
import Controls from '../../../../../../components/Entry/Controls'

const styles = {
    container_info: {
        padding: '3px 3px 3px 3px'
    },
    list_param: { color: '#748291', fontSize: '0.7rem', paddingBottom: '0.5rem' },
    container_chart: {
        padding: '3px 3px 3px 3px',
        backgroundColor: '#f8f8f8',
        borderRadius: '0.5rem'
    }
}

function NaturalRegeneration(props) {
    const { naturalRegenerationData } = props
    const [regenerationData, setRegenerationData] = useState(null)
    const [abundanceList, setAbundanceList] = useState([
        { id: 1, title: 'Moins abondantes' },
        { id: 2, title: 'Abondantes' },
        { id: 3, title: 'Très abondantes' }
    ])
    const [repartitionList, setRepartitionList] = useState([{ id: 1, title: 'Dispersée' },{ id: 2, title: 'Concentrée' }])
    const [abundanceSelected, setAbundanceSelected] = useState(null)
    const [repartitionSelected, setRepartitionSelected] = useState(null)

    useEffect(() => {
        if (naturalRegenerationData) {
            let abundance = abundanceList.find((item) => item.title === naturalRegenerationData.abundance)
            let repartition = repartitionList.find((item) => item.title === naturalRegenerationData.repartition)
            setRepartitionSelected(repartition?.id)
            setAbundanceSelected(abundance?.id)
            setRegenerationData(naturalRegenerationData)
        }
    }, [naturalRegenerationData, regenerationData, abundanceSelected, abundanceList, repartitionSelected, repartitionList])

    return (
        <>
            <Paper
                sx={{
                    padding: '0.4rem',
                    borderRadius: '0.5rem',
                    display: 'inline-flex',
                    width: '95%',
                    backgroundColor: '#f1f1f1'
                }}
            >
                <Container style={styles.container_info}>
                    <Container style={{ ...styles.container_info, paddingBottom: '0.5rem' }}>
                        <Typography variant="p" sx={{ color: '#6f7e8e', fontSize: '0.7rem' }}>
                            Régénération naturelle
                        </Typography>
                    </Container>
                    <Container style={styles.container_info}>
                        <Grid container>
                            <Grid item xs={2} sx={{ padding: '10px 0px 10px 0px' }}>
                                <Typography variant="p" sx={{ color: '#6f7e8e', fontSize: '0.7rem' }}>
                                    <b>Nombre :</b>
                                </Typography>
                            </Grid>
                            <Grid item xs={10}>
                                <Typography variant="p" sx={{ color: '#6f7e8e', fontSize: '0.7rem' }}>
                                    <Controls.RadioGroup
                                        name="recipient_polygon"
                                        items={abundanceList}
                                        value={abundanceSelected}
                                        isDisabled={true}
                                    />
                                </Typography>
                            </Grid>
                        </Grid>
                    </Container>
                    <Container style={styles.container_info}>
                        <Grid container>
                            <Grid item xs={2} sx={{ padding: '10px 0px 10px 0px' }}>
                                <Typography variant="p" sx={{ color: '#6f7e8e', fontSize: '0.7rem' }}>
                                    <b>Répartition :</b>
                                </Typography>
                            </Grid>
                            <Grid item xs={10}>
                                <Typography variant="p" sx={{ color: '#6f7e8e', fontSize: '0.7rem' }}>
                                    <Controls.RadioGroup
                                        name="recipient_polygon"
                                        items={repartitionList}
                                        value={repartitionSelected}
                                        isDisabled={true}
                                    />
                                </Typography>
                            </Grid>
                        </Grid>
                    </Container>
                    <Container style={styles.container_info}>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography variant="p" sx={{ color: '#6f7e8e', fontSize: '0.7rem' }}>
                                    <b>Age :</b>
                                </Typography>
                            </Grid>
                            <Grid item xs={10}>
                                <Typography variant="p" sx={{ color: '#6f7e8e', fontSize: '0.7rem' }}>
                                    {[naturalRegenerationData?.age, ' ans'].join('')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Container>
                </Container>
            </Paper>
        </>
    )
}

export default NaturalRegeneration
